export enum Theme {
  default = 'default',
  diamond = 'diamond',
}

export interface Props {
  theme: Theme,
}
